// extracted by mini-css-extract-plugin
export var chevron = "_lr-3";
export var chevronRotated = "_lr-4";
export var image = "_lr-1";
export var imageContainer = "_lr-0";
export var shippingAddress = "_lr-2";